import React, { createRef } from "react";
import { Col, Container, Row, Form as Bform, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import action from "../../../Actions";
import Common, * as commondata from "../../../Common";
import Header from "../../../Header";
import Back from "../../UI/Back";
import Button from "../../UI/Button";
import Message from "../../UI/Message";
import { Formik, Form, Field, useFormikContext } from "formik";
import { string, object, number, array } from "yup";
import Loading from "../../UI/Loading";
import ReactSelect, { components } from "react-select";
import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui-dist/jquery-ui.css";
import ToolBar from "../../editor/ToolBar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { withRouter, Link } from "react-router-dom";
import ReactCustomSelect from "../customSelect/ReactCustomSelect";
import AsyncSelect from "react-select/async";
import axios, { CancelToken } from "axios";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Uploader from "../../UI/Uploader";
import updateAttachmentData from "../../../Actions/updateAttachmentData";
import { clearAllAttachment } from "../../../Actions/clearAllAttachment";
import Error from "../../Error";
import ImagePreview from "../../../components/UI/ImagePreview";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import CustomOption from "../../CustomOption";
import Modal from "../../UI/modal/Modal";

class AddListing extends Common {
  constructor(props) {
    super(props);

    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      attr_set:
        this.props.location.state?.board_data ||
        this.props.location.state?.data,
      loginInfo: {},
      attributes: [],
      loading: false,
      formdata: {},
      users: [],
      customattachments: [],
      isEffortCalled: false,
      attachments: [],
      isSaving: false,
      getChildBoardValue: [],
      apiOptions: [],
      apiObjectValue: {},
      attachShow: false,
      childBoards: [],
      showUploadModal: false,
      isAddPageUpload: false,
      defaultValue: {},
      allEfforts: [],
      mainImageUpload: false,
      createBoard: {
        board: false,
        message: "",
        title: "",
        position: "bottom-end",
      },
      boarddata: {},
      attachImages: {},
      defaultVal: "",
    };
    this.clearform = createRef([]);
    this.clearFormSelect = createRef([]);
    this.clearFormSelectApi = createRef([]);
    this.assignToSelect = createRef(null);
    this.ckEditorRef = createRef(null);
    this.apiValuesObj = {};
    this.newarrayAll = [];
    this.cancelFileUpload = React.createRef(null);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props !== prevProps) {
      this.setState({
        ...this.state,
        loginInfo: { ...this.state.loginInfo, ...this.props.logindata },
        // attributes: this.props.attributes.attributes,
        loading: this.props.attributes.loading,
        // attachImages: this.props.uploadAtt,
      });
    }
  };

  customerFetchData = async (url, evt) => {
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (evt) {
        return Object.keys(data)
          .map((it) => ({
            label: `${data[it].name} (${it})`,
            value: it,
          }))
          .filter((fil) => fil.label.toLowerCase().includes(evt.toLowerCase()));
      } else {
        return Object.keys(data)
          .map((it) => ({
            label: `${data[it].name} (${it})`,
            value: it,
          }))
          .filter((fil) => fil.label.toLowerCase().includes(evt.toLowerCase()));
      }
    } catch (error) {
      console.log(error);
    }
  };
  toggleInputHandler = (formik, evt, item) => {
    const { name, value } = evt.target;
    formik.setFieldValue(
      name,
      value === "false" || value === "" ? true : false
    );
  };
  effortChangeHandler = (formik, evt, api_url, item) => {
    const value = +evt.target.value;

    const regex = /^\d*$/;

    if (evt.target.name == `${item.field}.effort_in_hours` && +value > 7) {
      return;
    }
    if (evt.target.name == `${item.field}.effort_in_days` && +value > 99) {
      return;
    }

    if (regex.test(value) || value === "") {
      formik.setFieldValue(evt.target.name, +value);
    }
  };
  erFetchData = async (url, evt) => {
    try {
      let api = url;
      api += evt ? evt : "";
      const response = await fetch(api);
      const resp = await response.json();
      const { data } = resp;
      if(!resp.data){
        return [];
      }
      if (evt) {
        if (resp.hasOwnProperty("data") && Array.isArray(resp.data)) {
          return data
            .map((it) => ({
              label: `${it.customer_tattle_uuid} - ${it.title && it.title.length > 75
                  ? it.title.slice(0, 75) + "..."
                  : it.title || ""
                }`,

              value: Number(it.customer_tattle_uuid),
            }))
            .filter((fil) =>
              fil.label.toLowerCase().includes(evt.toLowerCase())
            );
        } else {
          return Object.entries(resp).map(([key, val]) => {
            return { label: `${key} ${val.title}`, value: key, url: val.url };
          });
        }
      } else {
        if (resp.hasOwnProperty("data") && Array.isArray(resp.data)) {
          return data
            .map((it) => ({
              label: `${it.customer_tattle_uuid} - ${it.title && it.title.length > 75
                ? it.title.slice(0, 75) + "..."
                : it.title || ""
                }`,

              value: Number(it.customer_tattle_uuid),
            }))
            .filter((fil) =>
              fil.label.toLowerCase().includes(evt.toLowerCase())
            );
        } else {
          return Object.entries(resp).map(([key, val]) => {
            return { label: `${key} ${val.title}`, value: key, url: val.url };
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  childBoardFetchData = async (url, evt) => {
    let api = url;
    api += `&search=${evt ? evt : ""}`;
    try {
      if (evt) {
        const response = await fetch(api);
        const data = await response.json();
        if (data.code === 200) {
          const { data: newdata } = data;
          return newdata
            .map((it) => ({
              label: `${it.title}`,
              value: `${it.customer_tattle_uuid}`,
            }))
            .filter((fil) =>
              fil.label.toLowerCase().includes(evt.toLowerCase())
            );
        }
      } else {
        const response = await fetch(api);
        const data = await response.json();
        if (data.code === 200) {
          const { data: newdata } = data;
          return newdata.map((it) => ({
            label: `${it.title}`,
            value: `${it.customer_tattle_uuid}`,
          }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  loadAddress = async (url, evt, type) => {
    // this.freeze = true; //set mark for stop calls
    return new Promise(async (res, err) => {
      this.freeze = true; //set mark for stop calls
      //return promise
      let p = new Promise(async (res, err) => {
        if (evt) {
          if (this.freeze) clearTimeout(this.timer); //remove  prev timer
          this.timer = setTimeout(async () => {
            this.freeze = false;
            if (type === "customer") {
              const r = await this.customerFetchData(url, evt); //request
              res(r);
            } else if (
              ["er", "live_chat", "support_ticket", "market-feedback", "ideas", "projects"].includes(type)
            ) {
              const r = await this.erFetchData(url, evt); //request
              res(r);
            } else if (type === "child_board") {
              const r = await this.childBoardFetchData(url, evt); //request
              res(r);
            }
          }, 2000);
        } else {
          if (type === "customer") {
            const r = await this.customerFetchData(url, evt); //request
            res(r);
          } else if (
           ["er", "live_chat", "support_ticket", "market-feedback", "ideas", "projects"].includes(type)
          ) {
            const r = await this.erFetchData(url, evt); //request
            res(r);
          } else if (type === "child_board") {
            const r = await this.childBoardFetchData(url, evt); //request
            res(r);
          }
        }
      });
      p.then(function (x) {
        return res(x);
      });
    });
  };
  hideUiModal = () => {
    if (this.cancelFileUpload.current) {
      this.cancelFileUpload.current("User has cancel the file upload");
    }
    this.setState((state) => {
      return {
        ...state,
        showUploadModal: false,
      };
    });
  };

  fetchData = async (url, evt, field) => {
    try {
      if (evt && this.apiValuesObj[field].length > 0) {
        return this.apiValuesObj[field]
          .sort((a, b) =>
            a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1
          )
          .filter((item) =>
            item.label.toLowerCase().includes(evt.toLowerCase())
          );
      }
      const response = await fetch(url);
      const data = await response.json();
      let datas;
      if (Array.isArray(data)) {
        if (evt) {
          datas = data
            .filter((it) => it.value.toLowerCase().includes(evt.toLowerCase()))
            .map((i) => ({ label: i.value, value: i.id }))
            .sort((a, b) =>
              a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1
            );
        } else {
          datas = data
            .filter((it) => it.value.toLowerCase().includes(evt.toLowerCase()))
            .map((i) => ({ label: i.value, value: i.id }))
            .sort((a, b) =>
              a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1
            );
        }
      }
      let newdatasobject = { ...this.apiValuesObj };
      newdatasobject[field] = datas;
      this.apiValuesObj = newdatasobject;
      setTimeout(() => {
        this.setState((state) => {
          return {
            ...state,
            apiObjectValue: { ...state.apiObjectValue, newdatasobject },
            apiOptions: datas,
          };
        });
      }, 200);
      return datas;
    } catch (error) {
      console.log(error);
    }
  };
  getStoreData = (obj) => {
    const failedImagesIssue = [...this.newarrayAll];
    failedImagesIssue.push(obj);
    this.newarrayAll = failedImagesIssue;
  };

  newPromiseUploader = (formdata) => {
    let newarr = [];
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.state.apiUrl}attachment/upload`, formdata, {
          cancelToken: new CancelToken(
            (cancel) => (this.cancelFileUpload.current = cancel)
          ),
          headers: {
            "Content-Type": "multipart/formdata",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            resolve(resp);
          } else {
            reject(resp);
          }
        })
        .catch((error) => {
          const arrnewcon = [...this.newarrayAll];
          if (arrnewcon.length > 0) {
            let newfile = arrnewcon.find((item) => {
              return (
                item.name.toLowerCase() ===
                formdata.get("image").name.toLowerCase()
              );
            });
            if (!newfile) {
              this.getStoreData({
                name: formdata.get("image").name,
                message: error.message,
              });
            }
          } else {
            this.getStoreData({
              name: formdata.get("image").name,
              message: error.message,
            });
          }
          reject(error);
        });
    });
  };

  onSubmitAttachmentHandler = async (evt) => {
    evt.preventDefault();
    if (this.state.customattachments.length > 0) {
      this.setState((state) => {
        return {
          ...state,
          mainImageUpload: true,
        };
      });
      let newarray = [];
      const appPromis = this.state.customattachments.map((file) => {
        let formdata = new FormData();
        formdata.append("app_token", this.state.boarddata.app_token);
        formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
        formdata.append(`image`, file);
        const result = this.newPromiseUploader(formdata);
        result.then((resp) => {
          if (resp.data.code === 400 || resp.data.code === 1208) {
            const arrnewcon = [...this.newarrayAll];
            if (arrnewcon.length > 0) {
              let newfile = arrnewcon.find((item) => {
                return item.name.toLowerCase() === file.name.toLowerCase();
              });
              if (!newfile) {
                this.getStoreData({
                  name: file.name,
                  message: resp.data.message,
                });
              }
              // return;
            } else {
              this.getStoreData({
                name: file.name,
                message: resp.data.message,
              });
            }
          }
        });
        return result;
      });

      const request = await Promise.allSettled(appPromis);
      if (request.length > 0) {
        let newfilearray = {};
        request.forEach((it) => {
          if (it.status === "fulfilled") {
            const {
              data: { data },
            } = it.value;
            newfilearray = { ...newfilearray, ...data };
          } else {
          }
        });

        if (
          newfilearray &&
          request.every(
            (item) =>
              item.status === "fulfilled" && item.value.data.code === 200
          )
        ) {
          setTimeout(() => {
            this.setState((state) => {
              return {
                ...state,
                attachImages: { ...this.state.attachImages, ...newfilearray },
                customattachments: [],
                saveImageFile: { ...state.saveImageFile, ...newfilearray },
                showUploadModal: false,
                mainImageUpload: false,
              };
            });
          }, 200);

          // this.props.saveAttachment({ attachments: newfilearray });
        } else {
          this.setState((state) => {
            return { ...state, showUploadModal: true, mainImageUpload: false };
          });
        }
      }
    }
  };
  attachmentUploadHandler = (evt) => {
    const files = evt.target.files;
    const attachments = [...this.state.customattachments];
    for (let i = 0; i < files.length; i++) {
      attachments.push(files[i]);
    }

    this.setState((state) => {
      return {
        ...state,
        customattachments: attachments,
      };
    });
  };
  removeImageHandler = (index) => {
    const attachments = [...this.state.customattachments];
    attachments.splice(index, 1);
    const alertError = [...this.newarrayAll];
    const indexr = alertError.findIndex((item) => item.name === name);
    alertError.splice(indexr, 1);
    this.newarrayAll = alertError;
    this.setState((state) => {
      return {
        ...state,
        customattachments: attachments,
      };
    });
  };
  getModalContent = () => {
    return (
      <>
        <form onSubmit={this.onSubmitAttachmentHandler}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="file-select">
                <div className="file-select-name" id="noFile2">
                  <div>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.4966 2.21875C10.6066 2.25362 7.84482 3.41715 5.80115 5.46082C3.75748 7.50449 2.59395 10.2663 2.55908 13.1562C2.59395 16.0462 3.75748 18.808 5.80115 20.8517C7.84482 22.8953 10.6066 24.0589 13.4966 24.0938C16.3866 24.0589 19.1483 22.8953 21.192 20.8517C23.2357 18.808 24.3992 16.0462 24.4341 13.1562C24.3992 10.2663 23.2357 7.50449 21.192 5.46082C19.1483 3.41715 16.3866 2.25362 13.4966 2.21875ZM19.7466 13.9375H14.2778V19.4062H12.7153V13.9375H7.24658V12.375H12.7153V6.90625H14.2778V12.375H19.7466V13.9375Z"
                        fill="#717171"
                      ></path>
                    </svg>
                  </div>
                  Add File
                </div>
                <input
                  type="file"
                  name="chooseFile"
                  id=""
                  title=""
                  multiple
                  onChange={this.attachmentUploadHandler}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="custom_image">
                <div className="afterupload-image">
                  {this.state.customattachments.map((file, index) => {
                    const imgg = URL.createObjectURL(file);
                    return (
                      <div class="img-box">
                        <ImagePreview
                          headImage={imgg}
                          ext={file.name.split(".").pop()}
                          imgLength={this.state.customattachments}
                          width="128px"
                          height="58px"
                        />

                        <figure>
                          {file?.name?.slice(0, 6) +
                            "." +
                            file?.name.split(".").pop()}
                        </figure>
                        <div
                          class="delete"
                          onClick={() =>
                            this.removeImageHandler(index, file.name)
                          }
                        >
                          <svg
                            width="11"
                            height="10"
                            viewBox="0 0 11 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <title>Remove</title>
                            <path
                              d="M8.21973 2.5L3.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M3.21973 2.5L8.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {this.newarrayAll.length > 0 && (
                  <div className="image_failed_list">
                    {" "}
                    <ul>
                      {this.newarrayAll.map((item, index) => (
                        <li>
                          <Alert variant="danger">
                            {item.name} : {item.message}
                          </Alert>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="cancl-cls"
              data-bs-dismiss="modal"
              onClick={this.hideUiModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-cls"
              disabled={this.state.mainImageUpload}
            >
              {this.state.mainImageUpload ? "Uploading..." : "Submit"}
            </button>
          </div>
        </form>
      </>
    );
  };
  removeCloneImages = (uuid, formik) => {
    const attachment = {
      ...delete formik.values["attachment"][uuid],
      ...formik.values["attachment"],
    };
    formik.setFieldValue("attachment", attachment);
  };
  componentDidMount = async () => {
    const ticket = this.props.match.params.ticketId;
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    let queryData = {};
    for (const [key, value] of params.entries()) {
      queryData[key] = value;
    }
    if (ticket) {
      this.setState((state) => {
        return {
          ...state,
          formdata: {
            ...state.formdata,
            ...queryData,
            [this.props.match.params.sync]: [+ticket],
          },
        };
      });
    }
    const dat = $(".date_change_format");
    dat.datepicker({
      dateFormat: "yy/mm/dd",
    });
    const data = this.getCommonData();
    const boarddata = await this.getBoardDetails(this.props.match.params.id);
    if (boarddata) {
      this.setState(
        { ...this.state, boarddata: { ...boarddata, ...data } },
        async () => {
          var title = this.props.title ? this.props.title : "";
          document.title = `${this.state.boarddata.attribute_set_name} | ${title}`;
          const attrInfo = {
            app_token: this.state.boarddata.app_token,
            attribute_set_key: this.props.match.params.id,
            show_on_form: true,
            attribute_status: true,
          };
          // this.getBoardAttributes(attrInfo);
          try {
            const response = await fetch(
              `${this.state.apiUrl}tattle/attributes`,
              {
                method: "post",
                body: JSON.stringify(attrInfo),
              }
            );

            const rdata = await response.json();
            if (rdata.code === 200) {
              this.setState((state) => {
                return {
                  ...state,
                  attributes: rdata.data,
                };
              });
            } else {
              this.setState((state) => {
                return {
                  ...state,
                  attributes: rdata.data || [],
                };
              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      );

      if (this.props.match.params.uuid) {
        const response = await fetch(`${this.state.apiUrl}tattle/rows`, {
          method: "POST",
          body: JSON.stringify({
            app_token: boarddata.app_token,
            attribute_set_key: this.props.match.params.id,
            customer_tattle_uuid: Number(this.props.match.params.uuid),
            attribute_set_type: boarddata.attribute_set_type,
          }),
        });
        const rdata = await response.json();
        if (rdata.code === 200) {
          const { data } = rdata;
          setTimeout(() => {
            this.setState((state) => {
              return {
                ...state,
                formdata: {
                  ...state.formdata,
                  ...data?.[0],
                },
              };
            });
          }, 100);
        }
        const childBoardResponse = await fetch(
          `${this.state.apiUrl}tattle/get-child-boards`,
          {
            method: "POST",
            body: JSON.stringify({
              app_token: boarddata.app_token,
              attribute_set_key: this.props.match.params.id,
              customer_tattle_uuid: +this.props.match.params.uuid,
            }),
          }
        );
        const rdatachild = await childBoardResponse.json();
        if (rdatachild.code === 200) {
          this.setState((state) => {
            return {
              ...state,
              childBoards: rdatachild.data,
            };
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: rdatachild.message,
                bg: "danger",
                title: "failure",
              },
            };
          });
        }
      }
    }
  };

  getBoardAttributes = (info) => {
    this.props.getBoardAttributes(info);
  };

  onChangeHandler = (event) => {
    event.preventDefault();

    const { name, value } = event.target;
    const fdata = { ...this.state.formdata };
    if (name === "country" || name === "gender") {
      fdata[name] = [value];
    } else {
      fdata[name] = value;
    }
    this.setState({
      ...this.state,
      formdata: { ...this.state.formdata, ...fdata },
    });
  };
  removeNoteImages = (id) => {
    const newimage = {
      ...delete this.state.attachImages[id],
      ...this.state.attachImages,
    };
    this.setState({ ...this.state, attachImages: newimage });
  };
  getCallEffortApi = async (api) => {
    const response = await fetch(`${this.state.apiUrl}get-efforts`);
    const rdata = await response.json();
    setTimeout(() => {
      this.setState((state) => {
        return {
          ...state,
          allEfforts: rdata,
          isEffortCalled: true,
        };
      });
    });
  };

  previewImage = (image_url) => {
    const exten = image_url.split(".").pop();
    const checkexten = ["pdf", "docx", "csv"];
    if (!checkexten.includes(exten)) {
      const image_window = window.open("", "_blank");
      image_window.document.write(`
      <html>
        <head>
        </head>
        <body>
          <img src=${image_url} alt="Example" height="100%" width="100%">
        </body>
      </html>
`);
    } else {
      window.open(image_url, "_blank");
    }
  };
  convertDateFormat = (date) => {
    if (!date) {
      return null;
    }
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };
  reactDatePickerHandler = (evt, formik, field) => {
    let date = this.convertDateFormat(evt);
    formik.setFieldValue(field, date);
  };
  getBlobImages = (images, ind) => {
    const blob = images?.file_url;
    const ext = images?.file_name?.split(".").pop();
    const allow_images = ["jpg", "png", "jpeg"];

    return (
      <div className="img-box addticket">
        <Error>
          <ImagePreview
            headImage={blob}
            ext={ext}
            width="150px"
            height="80px"
          />{" "}
        </Error>
        <figure>
          {images?.file_name?.slice(0, 6) +
            "..." +
            images?.file_name?.slice(images?.file_name.length - 1, 6) +
            "." +
            ext}
        </figure>
        <div className="delete" onClick={() => this.removeNoteImages(ind)}>
          <svg
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.21973 2.5L3.21973 7.5"
              stroke="#737373"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M3.21973 2.5L8.21973 7.5"
              stroke="#737373"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>
    );
  };
  editorHandleChange = (val, formik, field) => {
    this.setState({ ...this.state, editorState: val }, () => {
      formik.setFieldValue(
        field,
        stateToHTML(this.state.editorState.getCurrentContent())
      );
    });
  };
  getPeoplesCall = async (evt, apiUrl) => {
    if (evt && this.state.users.length > 0) {
      return this.state.users.filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase())
      );
    }
    const resp = await fetch(apiUrl);
    const rdata = await resp.json();

    const newdata = Object.entries(rdata).map(([key, val]) => {
      return {
        label: val.name,
        value: val.user_uuid,
        profile_image: val.profile_image,
      };
    });
    this.setState((state) => {
      return {
        ...state,
        users: newdata,
      };
    });
    return newdata;
  };
  uploadAttachmentInForm = (evt) => {
    const images = [...this.state.attachments];
    const { files } = evt.target;
    Array.from(files).forEach((item) => {
      images.push(item);
    });
    this.setState({ ...this.state, attachments: images });
  };

  removeFormAttachHandler = (index) => {
    const images = [...this.state.attachments];
    images.splice(index, 1);
    this.setState({ ...this.state, attachments: images });
  };

  removeImage = (ind) => {
    const attachments = [...this.state.attachments];
    attachments.splice(ind, 1);
    this.setState({ ...this.state, attachments });
  };

  getBase64 = (imgg, ind) => {
    let extension = imgg.name.split(".").pop();
    let imagedata = "";
    const exten_array = ["jpg", "jpeg", "png"];
    if (exten_array.includes(extension)) {
      const url = URL.createObjectURL(imgg);
      imagedata = <img src={url} width="93" height="44" />;
    } else {
      imagedata = (
        <i
          className="fa fa-file"
          style={{
            fontSize: "44px",
            display: "flex",
            justifyContent: "center",
          }}
        ></i>
      );
    }

    return (
      <div className="img-box">
        {imagedata}
        <figure>
          {imgg.name.slice(0, 7) +
            "..." +
            imgg.name.slice(imgg.name.length - 1, 3) +
            "." +
            imgg.name.split(".").pop()}
        </figure>
        <div className="delete">
          <span onClick={() => this.removeImage(ind)}>
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.54492 3.11621H2.58368H10.8938"
                stroke="#D1D1D1"
                stroke-width="1.33"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M4.14115 3.11634V2.07758C4.14115 1.80208 4.25059 1.53787 4.44539 1.34306C4.6402 1.14826 4.90441 1.03882 5.17991 1.03882H7.25743C7.53292 1.03882 7.79714 1.14826 7.99194 1.34306C8.18675 1.53787 8.29619 1.80208 8.29619 2.07758V3.11634M9.85433 3.11634V10.3877C9.85433 10.6632 9.74489 10.9274 9.55008 11.1222C9.35528 11.317 9.09106 11.4264 8.81557 11.4264H3.62177C3.34627 11.4264 3.08206 11.317 2.88725 11.1222C2.69245 10.9274 2.58301 10.6632 2.58301 10.3877V3.11634H9.85433Z"
                stroke="#D1D1D1"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M5.17969 5.71313V8.82941"
                stroke="#D1D1D1"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M7.25781 5.71313V8.82941"
                stroke="#D1D1D1"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
        </div>
      </div>
    );
  };

  uploadAttachment = async (evt) => {
    this.setState((state) => {
      return {
        ...state,
        showUploadModal: true,
      };
    });
    // const files = evt.target.files;
    // let inputs = {
    //   images: [...files],
    //   app_token: this.state.boarddata.app_token,
    //   attribute_set_key: this.props.match.params.id,
    //   product_key: process.env.REACT_APP_PRODUCT_KEY,
    //   key: "add_listing",
    // };

    // if (inputs.images.length > 0) {
    //   const promiseImages = inputs.images;
    //   const allPro = promiseImages.map((item) => {
    //     let formdata = new FormData();
    //     formdata.append("app_token", inputs.app_token);
    //     formdata.append("product_key", inputs.product_key);
    //     formdata.append(`image`, item);

    //   return new Promise(async (resolve, reject) => {
    //     const resp = await axios
    //       .post(`${this.state.apiUrl}attachment/upload`, formdata)
    //       .then((resp) => {
    //         if (resp.status === 200) {
    //           resolve(resp);
    //         }
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // });
    // const requests = await Promise.allSettled(allPro);
    // if (requests.length > 0) {
    //   let newfilearray = {};
    //   requests.forEach((it) => {
    //     if (it.status === "fulfilled") {
    //       const {
    //         data: { data },
    //       } = it.value;
    //       newfilearray = { ...newfilearray, ...data };
    //     }
    //   });

    //     const newImages = { ...this.state.attachImages, ...newfilearray };
    //     setTimeout(() => {
    //       this.setState((state) => {
    //         return {
    //           ...state,
    //           isAddPageUpload: false,
    //           attachImages: newImages,
    //         };
    //       });
    //     });
    //   }
    // }
  };
  getTotalHours = (days, hours) => {
    let total = 0;
    if (days && hours) {
      total = +days * 8 + +hours;
    } else if (days) {
      total = +days * 8;
    } else if (hours) {
      total = +hours;
    }
    return total;
  };
  removeBlankValues = (obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value === "") {
          delete obj[key];
        } else if (Array.isArray(value) && value.length === 0) {
          delete obj[key];
        } else if (typeof value === "object" && !Array.isArray(value)) {
          this.removeBlankValues(value);
          if (Object.keys(value).length === 0) {
            delete obj[key];
          }
        }
      }
    }
    return obj;
  };
  getFormattedValue = (item, values) => {
    const { effort_in_days, effort_in_hours } = values[item];

    let effort = {
      total_hours: this.getTotalHours(effort_in_days, effort_in_hours),
      effort_in_days: +effort_in_days || 0,
      effort_in_hours: +effort_in_hours || 0,
    };

    let resultKey;
    let newObj = Object.keys(this.state.allEfforts);
    for (let i = newObj.length - 1; i >= 0; i--) {
      const key = newObj[i];
      const value = this.state.allEfforts[key];
      if (effort.total_hours >= value?.total_hours) {
        resultKey = key;
      }
    }
    effort = {
      effort: resultKey || 0,
      ...effort,
    };
    return effort;
  };

  formSubmitHandler = async (values) => {
    this.setState({ ...this.state, isSaving: true });
    let listing_form_submit = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.id,
      attribute_set_type: this.state.boarddata.attribute_set_type,
    };

    //todo assign to chck
    if (this.state.boarddata.attribute_set_type === 3) {
      listing_form_submit = {
        ...listing_form_submit,
        reporter: this.state.boarddata.user_uuid,
      };
    }
    if (this.state.boarddata.attribute_set_type == 4) {
      listing_form_submit = {
        ...listing_form_submit,
        assign_to: values.assign_to,
      };
    }
    let attachmentclone = {};

    if (values.attachment || this.state.attachImages) {
      attachmentclone = {
        ...attachmentclone,
        ...values.attachment,
        ...this.state.attachImages,
      };
    } else {
      attachmentclone = {
        ...this.state.attachImages,
      };
    }
    let newruselt = {};
    if (
      values.hasOwnProperty("effort") ||
      values.hasOwnProperty("qa_effort") ||
      values.hasOwnProperty("dev_effort")
    ) {
      for (let item in values) {
        if (
          item === "effort" ||
          item === "qa_effort" ||
          item === "dev_effort"
        ) {
          newruselt = {
            ...newruselt,
            [item]: this.getFormattedValue(item, values),
          };
        }
      }
    }

    let dynamic_values = {
      ...listing_form_submit,
      ...this.state.formdata,
      ...values,
      ...newruselt,
      ...(this.props.match.params.uuid && {
        tattle_clone_id: Number(this.props.match.params.uuid),
      }),
      attachment: attachmentclone || [],
    };
    dynamic_values = {
      ...dynamic_values,
      ...(this.props.match.params.uuid && {
        ...delete dynamic_values["customer_tattle_uuid"],
      }),
    };

    // dynamically get the value from get rows object base on showon form
    let dynamicvaluesnew = {};
    this.state.attributes.forEach((item) => {
      dynamicvaluesnew[item.field] = dynamic_values[item.field];
    });

    if (values.hasOwnProperty("board")) {
      dynamicvaluesnew["board"] = values?.board;
    }

    let {
      attachment,
      customer_tattle_uuid,
      start_date,
      end_date,
      go_live_date,
      created_timestamp,
      updated_timestamp,
      ...rest
    } = dynamic_values;
    if (this.props.match.params.uuid) {
      rest = {
        ...listing_form_submit,
        ...dynamicvaluesnew,
        ...(this.props.match.params.uuid && {
          tattle_clone_id: Number(this.props.match.params.uuid),
        }),
        attachment,
      };
    } else {
      rest = {
        ...rest,
        attachment,
      };
    }
    if (rest.hasOwnProperty("description") && rest.description) {
      const regex = /^(<p>&nbsp;<\/p>)+|(<p>&nbsp;<\/p>)+$/g;
      let content = rest.description.replace(regex, "");
      rest = {
        ...rest,
        description: content,
      };
    }
    const response = await fetch(`${this.state.apiUrl}tattle/create`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.removeBlankValues(rest)),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      this.setState(
        {
          ...this.state,
          // createBoard: {
          //   ...this.state.createBoard,
          //   board: true,
          //   formdata: {},
          //   message: rdata.message,
          //   title: rdata.status,
          // },
          attachImages: null,
          isSaving: false,
        },
        () => {
          if (
            this.props.match.params.sync &&
            this.props.match.params.ticketId
          ) {
            this.props.history.push({
              pathname: `/tattle/${this.props.match.params.sync}/${this.props.match.params.ticketId}`,
            });
          } else {
            this.props.history.push({
              pathname: `/tattle/${rdata.data.attribute_set_key}/${rdata.data.customer_tattle_uuid}`,
            });
          }
        }
      );
      this.props.clearAllAttachment();
      // const { resetForm } = useFormikContext();
      // resetForm({ values: "" });
    } else {
      this.setState({
        ...this.state,
        createBoard: {
          ...this.state.createBoard,
          board: true,
          message: rdata.message,
          title: rdata.status,
          bg: "danger",
        },
        isSaving: false,
      });
    }
  };

  contentEditableHandle = (formik, field) => {
    const data = document
      .getElementById("content")
      .innerHTML.replaceAll("&nbsp;", "");
    data = data.replace(/<div><br[\/]?><[\/]?div>/g, "");

    if (data.trim().length > 0) {
      formik.setFieldValue(field, data);
    }
  };
  defineErrorHandler = (error) => {
    if (error?.indexOf(".") !== -1) {
      let errorgot = error?.split(".");

      return errorgot?.[1];
    } else {
      return error;
    }
  };
  getBackButton = () => {
    if (this.props.match.params.uuid) {
      return (
        <Back
          to={`/tattle/${this.props.match.params.id}/${this.props.match.params.uuid}`}
          className="txt-dark underline-none"
        />
      );
    }
    return (
      <Back
        to={`/tattle/${this.props.match.params.id}/list`}
        className="txt-dark underline-none"
      />
    );
  };
  handleFormatContent = (event, input) => {
    event.stopPropagation();
    document.getElementById("content").focus();
    if (input === "bold") {
      document.execCommand(input, false, null);
    }

    if (input === "italic") {
      document.execCommand(input, false, null);
    }

    if (input === "underline") {
      document.execCommand(input, false, null);
    }
    if (input === "insertOrderedList") {
      document.execCommand(input, false, null);
    }

    if (input === "createlink") {
      let url = prompt("Enter the link here: ", "http://", false);
      if (url) {
        document.execCommand(input, false, url);
      }
    }
  };

  clearForm = () => {
    this.setState({ formdata: {} });
  };
  handleChangeCkEditor = (editor, item, formik) => {
    formik.setFieldValue(item.field, editor.getData());
  };
  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    this.props.form.setFieldValue(
      this.props.field.name,
      stateToHTML(contentState)
    ); //stateToHTML imported from draft-js-export-html
  };
  getChildBoardValueHandler = (evt, formik) => {
    const { name, value } = evt.target;
    const setfiledvalue = [...this.state.getChildBoardValue];
    const index = setfiledvalue.indexOf(value);
    if (index !== -1) {
      setfiledvalue.splice(index, 1);
    } else {
      setfiledvalue.push(value);
    }

    this.setState(
      (state) => {
        return {
          ...state,
          getChildBoardValue: setfiledvalue,
        };
      },
      () => {
        formik.setFieldValue("board", this.state.getChildBoardValue);
      }
    );
  };

  customStyles = {
    multiValue: (base) => ({
      ...base,
      display: "flex",
      alignItems: "center", // Align items center
    }),
    control: (base) => ({
      ...base,
      display: "flex",
      alignItems: "center",
    }),
  };

  checkAndSetDefaultValue(item, formik, users) {
    const usersList = users || this.state.users;

    if (item.defaultvalue && !formik.values[item.field]) {
      // Assign the logged-in user UUID as the default value if the field is empty
      const useruuid = commondata.getCommonData().user_uuid;
      const defaultUser = usersList.find((it) => it.value === useruuid);

      if (defaultUser) {
        // Only update state if the default user is different from the current state
        if (
          !this.state.defaultValue?.[item.field] ||
          this.state.defaultValue?.[item.field].value !== defaultUser.value
        ) {
          this.setState((prevState) => ({
            defaultValue: {
              ...prevState.defaultValue,
              [item.field]: defaultUser,
            },
          }));
        }
        formik.setFieldValue(item.field, defaultUser.value);
      }
    } else if (formik.values[item.field]) {
      const selectedUser = usersList.find(
        (it) => it.value === formik.values[item.field]
      );

      if (
        !this.state.defaultValue?.[item.field] ||
        this.state.defaultValue?.[item.field].value !== selectedUser?.value
      ) {
        this.setState((prevState) => ({
          defaultValue: {
            ...prevState.defaultValue,
            [item.field]: selectedUser,
          },
        }));
      }
    } else {
      // Clear default value when there's no default or form value
      if (this.state.defaultValue?.[item.field]) {
        this.setState((prevState) => ({
          defaultValue: {
            ...prevState.defaultValue,
            [item.field]: null,
          },
        }));
      }
    }
  }

  render() {
    const fields = [];

    this.state.attributes?.forEach((item) => {
      let validation = {};
      if (item.is_required && item.attribute_type === "tel") {
        const phoneRegExp =
          /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        validation = {
          required: string()
            .required(this.firstUpper(item.headerName + " is required "))
            .matches(phoneRegExp, "Phone number is not valid")
            .max(10, "10 number is allowed"),
        };
      } else if (item.is_required && item.attribute_type === "url") {
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        validation = {
          required: string()
            .required(this.firstUpper(item.headerName + " is required "))
            .matches(urlRegex, "URL is not valid"),
        };
      } else if (item.attribute_type === "url") {
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        if (item.is_required) {
          validation = {
            required: string().required(
              this.firstUpper(item.headerName + " is required ")
            ),
          };
        }
        validation = {
          required: string().matches(urlRegex, "URL is not valid"),
        };
      } else if (item.is_required && item.attribute_type === "text") {
        validation = {
          required: string()
            .trim()
            .required(this.firstUpper(item.headerName + " is required ")),
        };
      } else if (item.is_required && item.attribute_type === "textarea") {
        validation = {
          required: string()
            .trim()
            .required(this.firstUpper(item.headerName + " is required ")),
        };
      } else if (item.is_required && item.attribute_type === "select") {
        validation = {
          required: item.is_multiple
            ? array()
                .min(1)
                .required(this.firstUpper(item.headerName + " is required "))
            : string()
                .required(this.firstUpper(item.headerName + " is required "))
                .transform((value) => {
                  return value && !Array.isArray(value) ? value : value[0];
                }),
        };
      } else if (item.is_required && item.attribute_type === "priority") {
        validation = {
          required: item.is_multiple
            ? array()
                .min(1)
                .required(this.firstUpper(item.headerName + " is required "))
            : string().required(
                this.firstUpper(item.headerName + " is required ")
              ),
        };
      } else if (item.is_required && item.attribute_type === "checkbox") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.attribute_type === "number") {
        if (item.is_required) {
          validation = {
            required: number()
              .required(this.firstUpper(item.headerName + " is required "))
              .min(0),
          };
        } else {
          validation = {
            required: number()
              .min(
                0,
                this.firstUpper(
                  item.headerName + " must be equal or greater than 0"
                )
              )
              .nullable(true)
              .transform((_, val) => (val ? Number(val) : null)),
          };
        }
      } else if (item.is_required && item.attribute_type === "radio") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.is_required && item.attribute_type === "api") {
        if (item.is_multiple) {
          validation = {
            required: array().required(
              this.firstUpper(item.headerName + " is required ")
            ),
          };
        } else {
          validation = {
            required: string().required(
              this.firstUpper(item.headerName + " is required ")
            ),
          };
        }
      } else if (item.is_required && item.attribute_type === "product") {
        if (item.is_multiple) {
          validation = {
            required: array().required(
              this.firstUpper(item.headerName + " is required ")
            ),
          };
        } else {
          validation = {
            required: string().required(
              this.firstUpper(item.headerName + " is required ")
            ),
          };
        }
      } else if (item.is_required && item.attribute_type === "assign_to") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.is_required && item.attribute_type === "customer") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.is_required && item.attribute_type === "assign_to") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.is_required && item.attribute_type === "category") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.is_required && item.attribute_type === "status") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.is_required && item.attribute_type === "board") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required ")
          ),
        };
      } else if (item.attribute_type === "tel") {
        const phoneRegExp =
          /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        validation = {
          required: string()
            .matches(phoneRegExp, "Phone number is not valid")
            .max(10, "10 number is allowed"),
        };
      } else if (item.attribute_type === "email") {
        validation = {
          required: string().email("Invalid Email"),
        };
      }
      fields.push({
        name: item.field,
        initialValue: this.state.formdata[item.field] || "",
        type: item.attribute_type,
        ...validation,
      });
    });

    const initialValues = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.initialValue])
    );
    const validObject = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.required])
    );
    const userSchema = object().shape(validObject);
    this.clearFormSelect = new Array(this.state.attributes.length).fill(
      createRef()
    );
    return (
      <>
        <Modal
          show={this.state.showUploadModal}
          className="tattle-Uppopup addImage"
          close={this.hideUiModal}
        >
          {this.getModalContent()}
        </Modal>
        {/* {Object?.keys(this.props.attributes.imageUploadAddListing).length >
          0 && <Uploader show={true} />} */}
        {this.state.createBoard.board && (
          <Message board={this.state.createBoard} />
        )}
        <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
          <Header
            brecum_name={{
              name: `${this.props.match.params.uuid ? "Clone" : "Add"}`,
              link: "list",
            }}
            brecum_page={this.state.boarddata.attribute_set_name}
          />
          {this.state.attributes.length > 0 ? (
            <Error>
              <Container fluid>
                <div className="page-content pt-1 new-content-main ">
                  <Row>
                    <div className="form-child-section createTicketERparent">
                      <div className="forms-field createTicketER">
                        <Formik
                          enableReinitialize
                          initialValues={initialValues}
                          validationSchema={userSchema}
                          onSubmit={(values, { resetForm }) => {
                            this.formSubmitHandler(values);
                            // resetForm({ values: "" });
                          }}
                        >
                          {(formik) => {
                            return (
                              <Form className="full-er">
                                <div className="title fs-5 mb-4 text-capitalize">
                                  {this.getBackButton()}
                                  {this.props.match.params.uuid
                                    ? "Clone"
                                    : "Add"}{" "}
                                  {this.state.boarddata.attribute_set_name}{" "}
                                </div>
                                <Row>
                                  {this.state.attributes?.map((item, index) => {
                                    if (item.attribute_type === "text") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`input-cls ${
                                                item.is_required && "required"
                                              }`}
                                              autoComplete={"off"}
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            {item?.min_length &&
                                              formik.values[item.field] &&
                                              formik.touched[item.field] &&
                                              formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
                                              Number(item.min_length) && (
                                                <p className="input-warning">
                                                  <i className="fas fa-exclamation-triangle"></i>
                                                  The recommended {item.headerName.toLowerCase()} length is at least{" "}
                                                  {item.min_length} characters.
                                                </p>
                                              )}
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }

                                    if (item.attribute_type === "email") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`form-control mb-3 ${
                                                item.is_required && "required"
                                              }`}
                                              autoComplete={"off"}
                                            />

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (
                                      item.attribute_type === "company_name"
                                    ) {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`form-control mb-3 ${
                                                item.is_required && "required"
                                              }`}
                                              autoComplete={"off"}
                                            />

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (
                                      item.attribute_type === "customer_type"
                                    ) {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`form-control mb-3 ${
                                                item.is_required && "required"
                                              }`}
                                              autoComplete={"off"}
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "cc") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`form-control mb-3 ${
                                                item.is_required && "required"
                                              }`}
                                              autoComplete={"off"}
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "age") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`form-control mb-3 ${
                                                item.is_required && "required"
                                              }`}
                                              autoComplete={"off"}
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "checkbox") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <input
                                            type={item.attribute_type}
                                            ref={(el) => (this.clearform = el)}
                                            placeholder={`${item.headerName}`}
                                            name={item.field}
                                            onChange={formik.handleChange}
                                            value={formik.values[item.field]}
                                            className={`input-cls ${
                                              item.is_required && "required"
                                            }`}
                                            autocomplete={"off"}
                                            onBlur={() =>
                                              formik.setFieldTouched(
                                                item.field,
                                                true
                                              )
                                            }
                                          />
                                          &nbsp;
                                          <label>
                                            {this.firstUpper(item.headerName)}
                                          </label>
                                          <Bform.Control.Feedback
                                            type="invalid"
                                            style={
                                              formik.errors[item.field] &&
                                              formik.touched[item.field]
                                                ? {
                                                    display: "block",
                                                  }
                                                : {}
                                            }
                                          >
                                            {formik.errors[item.field] &&
                                            formik.touched[item.field] ? (
                                              <div className="error">
                                                {formik.errors[item.field]}
                                              </div>
                                            ) : null}
                                          </Bform.Control.Feedback>
                                        </Col>
                                      );
                                    }

                                    if (
                                      item.headerName !== undefined &&
                                      item.attribute_type === "textarea"
                                    ) {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3 ck_editing"
                                          key={index}
                                        >
                                          <div className="inputbox-group mb-3">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <CKEditor
                                              editor={Editor}
                                              config={{
                                                removePlugins: [
                                                  "SourceEditing",
                                                  "Style",
                                                  "Table",
                                                  "ImageUpload",
                                                  "MediaEmbed",
                                                  "ImageToolbar",
                                                  "Indent",
                                                  "BlockQuote",
                                                  "TextTransformation",
                                                  "Heading",
                                                  "Essentials",
                                                ],
                                              }}
                                              data={
                                                formik.values[item.field]
                                                  ? formik.values[item.field]
                                                  : ""
                                              }
                                              ref={this.ckEditorRef}
                                              onChange={(event, editor) => {
                                                this.handleChangeCkEditor(
                                                  editor,
                                                  item,
                                                  formik
                                                );
                                              }}
                                              onBlur={(evt) =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            {item?.min_length &&
                                              formik.values[item.field] &&
                                              formik.touched[item.field] &&
                                              formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
                                              Number(item.min_length) && (
                                                <span className="description-warning">
                                                  <i className="fas fa-exclamation-triangle"></i>
                                                  The recommended {item.headerName.toLowerCase()} length is at least {item.min_length} characters.
                                                </span>
                                              )}


                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "radio") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group form_checkbox_validation">
                                            {item.options?.map((it, index) => {
                                              return (
                                                <>
                                                  <input
                                                    type={item.attribute_type}
                                                    ref={(el) =>
                                                      (this.clearform = el)
                                                    }
                                                    placeholder={`${item.headerName}`}
                                                    name={item.field}
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    value={
                                                      formik.values[item.field]
                                                    }
                                                    className={`input-cls ${
                                                      item.is_required &&
                                                      "required"
                                                    }`}
                                                    autocomplete={"off"}
                                                    onBlur={(evt) =>
                                                      formik.setFieldTouched(
                                                        item.field,
                                                        true
                                                      )
                                                    }
                                                  />{" "}
                                                  <label>
                                                    {this.firstUpper(
                                                      it.option_name
                                                    )}
                                                  </label>
                                                </>
                                              );
                                            })}
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "tel") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`input-cls ${
                                                item.is_required && "required"
                                              }`}
                                              autocomplete={"off"}
                                              onBlur={(evt) =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "url") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`input-cls ${
                                                item.is_required && "required"
                                              }`}
                                              autocomplete={"off"}
                                              onBlur={(evt) =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div class="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "number") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={item.attribute_type}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              min={0}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`input-cls ${
                                                item.is_required && "required"
                                              }`}
                                              autocomplete={"off"}
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "date") {
                                      const currentDate = new Date();
                                      const pastDate = formik.values[item.field]
                                        ? new Date(formik.values[item.field])
                                        : currentDate.setDate(
                                            currentDate.getDate() - 30
                                          );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group date">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <ReactDatePicker
                                              className="rasta-stripes"
                                              dateFormat="dd-MM-yyyy"
                                              selected={
                                                formik.values[item.field]
                                                  ? new Date(
                                                      formik.values[item.field]
                                                    )
                                                  : null
                                              }
                                              isClearable
                                              minDate={pastDate}
                                              placeholderText="dd-mm-yyyy"
                                              onChange={(evt) =>
                                                this.reactDatePickerHandler(
                                                  evt,
                                                  formik,
                                                  item.field
                                                )
                                              }
                                            />

                                            {/* <input
                                              type="date"
                                              name={item.field}
                                              className="form-control"
                                              value={formik.values[item.field]}
                                              onChange={formik.handleChange}
                                              autoComplete={"off"}
                                              // min={
                                              //   new Date()
                                              //     .toISOString()
                                              //     .split("T")[0]
                                              // }
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            /> */}
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "start_date") {
                                      const currentDate = new Date();
                                      const pastDate = formik.values[item.field]
                                        ? new Date(formik.values[item.field])
                                        : currentDate.setDate(
                                            currentDate.getDate() - 30
                                          );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group date">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>

                                            <ReactDatePicker
                                              className="rasta-stripes"
                                              dateFormat="dd-MM-yyyy"
                                              selected={
                                                formik.values[item.field]
                                                  ? new Date(
                                                      formik.values[item.field]
                                                    )
                                                  : null
                                              }
                                              minDate={pastDate}
                                              placeholderText="dd/mm/yyyy"
                                              onChange={(evt) =>
                                                this.reactDatePickerHandler(
                                                  evt,
                                                  formik,
                                                  item.field
                                                )
                                              }
                                            />

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "end_date") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group date">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>

                                            <ReactDatePicker
                                              className="rasta-stripes"
                                              dateFormat="dd-MM-yyyy"
                                              selected={
                                                formik.values[item.field]
                                                  ? new Date(
                                                      formik.values[item.field]
                                                    )
                                                  : null
                                              }
                                              minDate={
                                                formik.values["start_date"]
                                                  ? new Date(
                                                      formik.values[
                                                        "start_date"
                                                      ]
                                                    )
                                                  : new Date()
                                              }
                                              placeholderText="dd/mm/yyyy"
                                              onChange={(evt) =>
                                                this.reactDatePickerHandler(
                                                  evt,
                                                  formik,
                                                  item.field
                                                )
                                              }
                                            />

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (
                                      item.attribute_type === "go_live_date"
                                    ) {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group date">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>

                                            <ReactDatePicker
                                              className="rasta-stripes"
                                              dateFormat="dd-MM-yyyy"
                                              selected={
                                                formik.values[item.field]
                                              }
                                              minDate={
                                                formik.values["end_date"] ||
                                                new Date().setDate(
                                                  new Date().getDate()
                                                )
                                              }
                                              placeholderText="dd/mm/yyyy"
                                              onChange={(evt) =>
                                                this.reactDatePickerHandler(
                                                  evt,
                                                  formik,
                                                  item.field
                                                )
                                              }
                                            />

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "board") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >
                                              {this.firstUpper(item.headerName)}
                                            </label>
                                            <AsyncSelect
                                              cacheOptions
                                              defaultOptions
                                              loadOptions={(evt) =>
                                                this.loadAddress(
                                                  item.api_url,
                                                  evt,
                                                  "child_board"
                                                )
                                              }
                                              onChange={(value) => {
                                                formik.setFieldValue(
                                                  item.field,
                                                  value.value
                                                );
                                              }}
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "api") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <>
                                              <AsyncSelect
                                                placeholder={item.headerName}
                                                isMulti={item.is_multiple}
                                                cacheOptions
                                                styles={this.customStyles}
                                                ref={(el) =>
                                                  (this.clearFormSelect[index] =
                                                    el)
                                                }
                                                value={this.state.apiOptions?.find(
                                                  (ite) =>
                                                    ite.value ==
                                                    formik.values[item.field]
                                                )}
                                                defaultOptions
                                                isClearable={true}
                                                loadOptions={(evt) =>
                                                  this.fetchData(
                                                    item.api_url,
                                                    evt,
                                                    item.field
                                                  )
                                                }
                                                onBlur={() =>
                                                  formik.setFieldTouched(
                                                    item.field,
                                                    true
                                                  )
                                                }
                                                maxMenuHeight={175}
                                                onChange={(value) => {
                                                  formik.setFieldValue(
                                                    item.field,
                                                    !value
                                                      ? ""
                                                      : Array.isArray(value)
                                                      ? value.map(
                                                          (item) => item.value
                                                        )
                                                      : value.value
                                                  );
                                                }}
                                              />
                                            </>

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div class="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "toggle") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                        >
                                          <div className="inputbox-group">
                                            {" "}
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <div class="form-check form-switch me-1">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                name={`${item.field}`}
                                                value={
                                                  formik.values?.[item.field] ||
                                                  false
                                                }
                                                onChange={(evt) =>
                                                  this.toggleInputHandler(
                                                    formik,
                                                    evt,
                                                    item
                                                  )
                                                } // defaultValue={
                                                //   editField.rows[editField.field]
                                                // }
                                                // onChange={editField.toggleHandler}
                                                id="flexSwitchCheckChecked"
                                                // value={
                                                //   Boolean(
                                                //     editField.rows[
                                                //       editField.field
                                                //     ]
                                                //   ) || false
                                                // }
                                                // checked={
                                                //   Boolean(
                                                //     editField.rows[
                                                //       editField.field
                                                //     ]
                                                //   ) || false
                                                // }
                                              />
                                              <label
                                                class="form-check-label"
                                                for="flexSwitchCheckChecked"
                                              ></label>
                                            </div>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "product") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <>
                                              <AsyncSelect
                                                placeholder={item.headerName}
                                                isMulti={item.is_multiple}
                                                cacheOptions
                                                ref={(el) =>
                                                  (this.clearFormSelect[index] =
                                                    el)
                                                }
                                                value={this.state.apiOptions?.find(
                                                  (ite) =>
                                                    ite.value ==
                                                    formik.values[item.field]
                                                )}
                                                defaultOptions
                                                isClearable={true}
                                                loadOptions={(evt) =>
                                                  this.fetchData(
                                                    item.api_url,
                                                    evt,
                                                    item.field
                                                  )
                                                }
                                                onBlur={() =>
                                                  formik.setFieldTouched(
                                                    item.field,
                                                    true
                                                  )
                                                }
                                                maxMenuHeight={175}
                                                onChange={(value) => {
                                                  formik.setFieldValue(
                                                    item.field,
                                                    !value
                                                      ? ""
                                                      : Array.isArray(value)
                                                      ? value.map(
                                                          (item) => item.value
                                                        )
                                                      : value.value
                                                  );
                                                }}
                                              />
                                            </>

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div class="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (
                                      item.attribute_type === "project" ||
                                      item.attribute_type == "external_api"
                                    ) {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <>
                                              <AsyncSelect
                                                placeholder={item.headerName}
                                                isMulti={true}
                                                ref={(el) =>
                                                  (this.clearFormSelect[index] =
                                                    el)
                                                }
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={(evt) =>
                                                  this.loadAddress(
                                                    item.api_url,
                                                    evt,
                                                    item.field
                                                  )
                                                }
                                                maxMenuHeight={175}
                                                onChange={(value) => {
                                                  formik.setFieldValue(
                                                    item.field,
                                                    Array.isArray(value)
                                                      ? value.map(
                                                          (item) => item.value
                                                        )
                                                      : value.value
                                                  );
                                                }}
                                                onBlur={() =>
                                                  formik.setFieldTouched(
                                                    item.field,
                                                    true
                                                  )
                                                }
                                              />
                                            </>

                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "select") {
                                      const options = item.options?.map(
                                        (item) => ({
                                          ...item,
                                          label: item.option_name,
                                          value: item._id,
                                        })
                                      );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <Field
                                              placeholder={item.headerName}
                                              isMulti={item.is_multiple}
                                              options={options}
                                              key={index}
                                              refs={(el) =>
                                                (this.clearFormSelect[index] =
                                                  el)
                                              }
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                              maxMenuHeight={175}
                                              name={item.field}
                                              component={ReactCustomSelect}
                                              formik={formik}
                                              item={item}
                                            />
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (
                                      item.attribute_type === "multi-select"
                                    ) {
                                      const options = item.options?.map(
                                        (item) => ({
                                          ...item,
                                          label: item.option_name,
                                          value: item._id,
                                        })
                                      );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <Field
                                              placeholder={item.headerName}
                                              isMulti={true}
                                              options={options}
                                              key={index}
                                              refs={(el) =>
                                                (this.clearFormSelect[index] =
                                                  el)
                                              }
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                              maxMenuHeight={175}
                                              name={item.field}
                                              component={ReactCustomSelect}
                                              formik={formik}
                                              item={item}
                                            />
                                          </div>
                                        </Col>
                                      );
                                    }
                                    // effort field
                                    if (item.attribute_type === "effort") {
                                      // const options = item?.options?.map(
                                      //   (item) => ({
                                      //     ...item,
                                      //     label: item.option_name,
                                      //     value: item._id,
                                      //   })
                                      // );
                                      if (
                                        this.state.allEfforts.length == 0 &&
                                        this.state.users.length > 0
                                      ) {
                                        this.getCallEffortApi(item.api_url);
                                      }
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <div className="input-group">
                                              <div className="groupday">
                                                {" "}
                                                <input
                                                  type="text"
                                                  className="form-control effort-fields"
                                                  value={
                                                    formik.values?.[
                                                      item.field
                                                    ]?.["effort_in_days"] || 0
                                                  }
                                                  name={`${item.field}.effort_in_days`}
                                                  onChange={(evt) =>
                                                    this.effortChangeHandler(
                                                      formik,
                                                      evt,
                                                      item.api_url,
                                                      item
                                                    )
                                                  }
                                                  autoComplete="off"
                                                />
                                              </div>
                                              <div className="grouphour">
                                                {" "}
                                                <input
                                                  type="text"
                                                  className="form-control effort-fields"
                                                  value={
                                                    formik.values?.[
                                                      item.field
                                                    ]?.["effort_in_hours"] || 0
                                                  }
                                                  name={`${item.field}.effort_in_hours`}
                                                  onChange={(evt) =>
                                                    this.effortChangeHandler(
                                                      formik,
                                                      evt,
                                                      item.api_url,
                                                      item
                                                    )
                                                  }
                                                  autoComplete="off"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "name") {
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <input
                                              type={"text"}
                                              ref={(el) =>
                                                (this.clearform = el)
                                              }
                                              placeholder={`${item.headerName}`}
                                              name={item.field}
                                              onChange={formik.handleChange}
                                              value={formik.values[item.field]}
                                              className={`input-cls ${
                                                item.is_required && "required"
                                              }`}
                                              autocomplete={"off"}
                                              onBlur={(evt) =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div class="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "priority") {
                                      const options = item.options?.map(
                                        (item) => ({
                                          ...item,
                                          label: item.option_name,
                                          value: item._id,
                                        })
                                      );

                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <Field
                                              placeholder={item.headerName}
                                              isMulti={item.is_multiple}
                                              options={options}
                                              key={index}
                                              refs={(el) =>
                                                (this.clearFormSelect[index] =
                                                  el)
                                              }
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                              maxMenuHeight={175}
                                              name={item.field}
                                              component={ReactCustomSelect}
                                              formik={formik}
                                            />
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "category") {
                                      const options = item.options;
                                      const newoptions = options?.map(
                                        (item) => ({
                                          label: item.name,
                                          value: item._id,
                                        })
                                      );
                                      const values = newoptions.filter(
                                        (it) =>
                                          it.value === formik.values[item.field]
                                      );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <ReactSelect
                                              // isMulti={item.is_multiple}
                                              options={newoptions || []}
                                              maxMenuHeight={175}
                                              ref={(el) =>
                                                (this.clearFormSelect[index] =
                                                  el)
                                              }
                                              value={values}
                                              name="label"
                                              placeholder={this.firstUpper(
                                                item.headerName
                                              )}
                                              onChange={(value) =>
                                                formik.setFieldValue(
                                                  item.field,
                                                  value.value
                                                )
                                              }
                                            />
                                          </div>
                                          <Bform.Control.Feedback
                                            type="invalid"
                                            style={
                                              formik.errors[item.field] &&
                                              formik.touched[item.field]
                                                ? {
                                                    display: "block",
                                                  }
                                                : {}
                                            }
                                          >
                                            {formik.errors[item.field] &&
                                            formik.touched[item.field] ? (
                                              <div className="error">
                                                {formik.errors[item.field]}
                                              </div>
                                            ) : null}
                                          </Bform.Control.Feedback>
                                        </Col>
                                      );
                                    }

                                    if (item.attribute_type === "assign_to") {
                                      // Call the helper function to handle default value logic
                                      this.checkAndSetDefaultValue(
                                        item,
                                        formik
                                      );

                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >
                                              {`${this.firstUpper(
                                                item.headerName
                                              )}`}
                                            </label>
                                            <AsyncSelect
                                              cacheOptions
                                              defaultOptions
                                              loadOptions={(evt) =>
                                                this.getPeoplesCall(
                                                  evt,
                                                  item.api_url
                                                )
                                              }
                                              isClearable
                                              components={{
                                                Option: CustomOption,
                                              }}
                                              isMulti={item.is_multiple}
                                              name="label"
                                              maxMenuHeight={175}
                                              ref={this.assignToSelect}
                                              value={
                                                this.state.defaultValue?.[
                                                  item.field
                                                ] || ""
                                              }
                                              placeholder={this.firstUpper(
                                                item.headerName
                                              )}
                                              onChange={(value) => {
                                                if (!value) {
                                                  // Clear selection
                                                  this.setState({
                                                    defaultValue: null,
                                                  }); // Clear state
                                                  formik.setFieldValue(
                                                    item.field,
                                                    ""
                                                  ); // Clear formik value
                                                } else {
                                                  // Update selection
                                                  this.setState({
                                                    defaultValue: value,
                                                  });
                                                  formik.setFieldValue(
                                                    item.field,
                                                    value.value
                                                  );
                                                }
                                              }}
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                          </div>
                                          <Bform.Control.Feedback
                                            type="invalid"
                                            style={
                                              formik.errors[item.field] &&
                                              formik.touched[item.field]
                                                ? { display: "block" }
                                                : {}
                                            }
                                          >
                                            {formik.errors[item.field] &&
                                            formik.touched[item.field] ? (
                                              <div className="error">
                                                {formik.errors[item.field]}
                                              </div>
                                            ) : null}
                                          </Bform.Control.Feedback>
                                        </Col>
                                      );
                                    }

                                    if (item.attribute_type === "monitoring") {
                                      const { options } = item;
                                      const userDetails =
                                        commondata.IsJsonString(
                                          this.state.boarddata.user_details
                                        )
                                          ? JSON.parse(
                                              this.state.boarddata.user_details
                                            )
                                          : "";

                                      //check todo
                                      let value = "";
                                      if (
                                        item.defaultvalue &&
                                        !formik.values[item.field]
                                      ) {
                                        let useruuid =
                                          commondata.getCommonData().user_uuid;
                                        value = this.state.users.filter(
                                          (it) => it.value === useruuid
                                        );
                                        setTimeout(() => {
                                          formik.setFieldValue(
                                            item.field,
                                            value
                                          );
                                        }, 200);
                                      } else {
                                        value = this.state.users?.filter((it) =>
                                          it.value
                                            ? formik.values[
                                                item.field
                                              ].includes(it.value)
                                            : ""
                                        );
                                      }

                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <AsyncSelect
                                              cacheOptions
                                              defaultOptions
                                              loadOptions={(evt) =>
                                                this.getPeoplesCall(
                                                  evt,
                                                  item.api_url
                                                )
                                              }
                                              isClearable
                                              components={{
                                                Option: CustomOption,
                                              }}
                                              isMulti={item.is_multiple}
                                              name="label"
                                              maxMenuHeight={175}
                                              ref={this.assignToSelect}
                                              value={value}
                                              placeholder={this.firstUpper(
                                                item.headerName
                                              )}
                                              onChange={(value) => {
                                                return formik.setFieldValue(
                                                  item.field,
                                                  !value
                                                    ? ""
                                                    : (value || []).map(
                                                        (it) => it.value
                                                      )
                                                );
                                              }}
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                          </div>
                                          <Bform.Control.Feedback
                                            type="invalid"
                                            style={
                                              formik.errors[item.field] &&
                                              formik.touched[item.field]
                                                ? {
                                                    display: "block",
                                                  }
                                                : {}
                                            }
                                          >
                                            {formik.errors[item.field] &&
                                            formik.touched[item.field] ? (
                                              <div className="error">
                                                {formik.errors[item.field]}
                                              </div>
                                            ) : null}
                                          </Bform.Control.Feedback>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "status") {
                                      const newoptions =
                                        item?.options &&
                                        item.options.map((item) => ({
                                          label: item.name,
                                          value: item._id,
                                        }));
                                      const statusVal = newoptions.filter(
                                        (it) =>
                                          it.value === formik.values[item.field]
                                      );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <ReactSelect
                                              // isMulti={item.is_multiple}
                                              options={newoptions || []}
                                              maxMenuHeight={175}
                                              ref={(el) =>
                                                (this.clearFormSelect[index] =
                                                  el)
                                              }
                                              value={statusVal}
                                              name="label"
                                              placeholder={this.firstUpper(
                                                item.headerName
                                              )}
                                              onChange={(value) =>
                                                formik.setFieldValue(
                                                  item.field,
                                                  value.value
                                                )
                                              }
                                            />
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (item.attribute_type === "reporter") {
                                      const { SingleValue, Option } =
                                        components;

                                      let newoptions = [];

                                      if (Array.isArray(item.options)) {
                                        newoptions = item?.options?.map(
                                          (item) => {
                                            return {
                                              ...item,
                                              label: item.name,
                                              value: item._id,
                                              profile: item.profile_image,
                                            };
                                          }
                                        );
                                      } else {
                                        for (let ip in item.options) {
                                          newoptions.push({
                                            label: item.options[ip].name,
                                            value: item.options[ip].user_uuid,
                                            profile:
                                              item.options[ip].profile_image,
                                          });
                                        }
                                      }
                                      let reportval = "";

                                      this.checkAndSetDefaultValue(
                                        item,
                                        formik
                                      );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <AsyncSelect
                                              cacheOptions
                                              defaultOptions
                                              loadOptions={(evt) =>
                                                this.getPeoplesCall(
                                                  evt,
                                                  item.api_url
                                                )
                                              }
                                              isClearable
                                              components={{
                                                Option: CustomOption,
                                              }}
                                              isMulti={item.is_multiple}
                                              options={newoptions || []}
                                              maxMenuHeight={175}
                                              name="label"
                                              ref={this.assignToSelect}
                                              value={
                                                this.state.defaultValue?.[
                                                  item.field
                                                ]
                                              }
                                              placeholder={this.firstUpper(
                                                item.headerName
                                              )}
                                              onChange={(value) =>
                                                formik.setFieldValue(
                                                  item.field,
                                                  !value ? "" : value.value
                                                )
                                              }
                                              onBlur={() =>
                                                formik.setFieldTouched(
                                                  item.field,
                                                  true
                                                )
                                              }
                                            />
                                          </div>
                                        </Col>
                                      );
                                    }
                                    if (
                                      [
                                        "textarea",
                                        "tel",
                                        "checkbox",
                                        "radio",
                                        "select",
                                        "attachment",
                                        "text",
                                        "number",
                                        "email",
                                        "date",
                                        "api",
                                        "er",
                                        "product",
                                      ].includes(item.attribute_type) === false
                                    ) {
                                      if (item.attribute_type === "customer") {
                                        return (
                                          <Col
                                            md={item.attribute_grid}
                                            className="mb-3"
                                            key={index}
                                          >
                                            <div className="inputbox-group">
                                              <label
                                                className={
                                                  "col-12 " +
                                                  (item.is_required
                                                    ? "form-label _required"
                                                    : "")
                                                }
                                              >{`${this.firstUpper(
                                                item.headerName
                                              )}`}</label>
                                              <>
                                                <input
                                                  type={item.attribute_type}
                                                  ref={(el) =>
                                                    (this.clearform = el)
                                                  }
                                                  placeholder={`${item.headerName}`}
                                                  name={item.field}
                                                  onChange={formik.handleChange}
                                                  value={
                                                    formik.values[item.field]
                                                  }
                                                  className={`input-cls ${
                                                    item.is_required &&
                                                    "required"
                                                  }`}
                                                  autoComplete={"off"}
                                                  onBlur={() =>
                                                    formik.setFieldTouched(
                                                      item.field,
                                                      true
                                                    )
                                                  }
                                                />
                                                {/* <AsyncSelect
                                                placeholder={item.headerName}
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={(evt) =>
                                                  this.loadAddress(
                                                    item.api_url,
                                                    evt,
                                                    "customer"
                                                  )
                                                }
                                                maxMenuHeight={175}
                                                onChange={(value) => {
                                                  formik.setFieldValue(
                                                    item.field,
                                                    Array.isArray(value)
                                                      ? value.map(
                                                          (item) => item.value
                                                        )
                                                      : value.value
                                                  );
                                                }}
                                                onBlur={() =>
                                                  formik.setFieldTouched(
                                                    item.field,
                                                    true
                                                  )
                                                }
                                             /> */}
                                              </>
                                              <Bform.Control.Feedback
                                                type="invalid"
                                                style={
                                                  formik.errors[item.field] &&
                                                  formik.touched[item.field]
                                                    ? {
                                                        display: "block",
                                                      }
                                                    : {}
                                                }
                                              >
                                                {formik.errors[item.field] &&
                                                formik.touched[item.field] ? (
                                                  <div className="error">
                                                    {formik.errors[item.field]}
                                                  </div>
                                                ) : null}
                                              </Bform.Control.Feedback>
                                            </div>
                                          </Col>
                                        );
                                      }
                                    }
                                    if (item.attribute_type === "release") {
                                      const options = item.options;
                                      const newoptions = options?.map(
                                        (item) => ({
                                          label: item.value,
                                          value: item.id,
                                        })
                                      );
                                      const values = newoptions.filter(
                                        (it) =>
                                          it.value === formik.values[item.field]
                                      );
                                      return (
                                        <Col
                                          md={item.attribute_grid}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <ReactSelect
                                              // isMulti={item.is_multiple}
                                              options={newoptions || []}
                                              maxMenuHeight={175}
                                              ref={(el) =>
                                                (this.clearFormSelect[index] =
                                                  el)
                                              }
                                              value={values}
                                              name="label"
                                              placeholder={this.firstUpper(
                                                item.headerName
                                              )}
                                              onChange={(value) =>
                                                formik.setFieldValue(
                                                  item.field,
                                                  value.value
                                                )
                                              }
                                            />
                                          </div>
                                          <Bform.Control.Feedback
                                            type="invalid"
                                            style={
                                              formik.errors[item.field] &&
                                              formik.touched[item.field]
                                                ? {
                                                    display: "block",
                                                  }
                                                : {}
                                            }
                                          >
                                            {formik.errors[item.field] &&
                                            formik.touched[item.field] ? (
                                              <div className="error">
                                                {formik.errors[item.field]}
                                              </div>
                                            ) : null}
                                          </Bform.Control.Feedback>
                                        </Col>
                                      );
                                    }

                                    if (item.attribute_type === "attachment") {
                                      return (
                                        <Col
                                          md={12}
                                          className="mb-3"
                                          key={index}
                                        >
                                          <div className="inputbox-group">
                                            <label
                                              className={
                                                "col-12 " +
                                                (item.is_required
                                                  ? "form-label _required"
                                                  : "")
                                              }
                                            >{`${this.firstUpper(
                                              item.headerName
                                            )}`}</label>
                                            <div
                                              className="file-upload"
                                              onClick={this.uploadAttachment}
                                            >
                                              {" "}
                                              <label
                                                className="file-name"
                                                htmlFor="custom-attachment"
                                              >
                                                <i
                                                  className="fa fa-plus hidden-sm"
                                                  aria-hidden="true"
                                                ></i>
                                                &nbsp;
                                                <span>
                                                  {" "}
                                                  {Array.from(
                                                    this.state.attachments
                                                  ).length > 0
                                                    ? Array.from(
                                                        this.state.attachments
                                                      ).length +
                                                      " files selected"
                                                    : this.state.isAddPageUpload
                                                    ? "Uploading..."
                                                    : "Choose Files"}
                                                </span>
                                              </label>
                                              <div className="file-selected"></div>
                                            </div>

                                            {/* <input
                                              type="file"
                                              className="form-control"
                                              onChange={this.uploadAttachment}
                                              autoComplete={"off"}
                                              id="custom-attachment"
                                              multiple={true}
                                              style={{ display: "none" }}
                                            /> */}
                                            <Bform.Control.Feedback
                                              type="invalid"
                                              style={
                                                formik.errors[item.field] &&
                                                formik.touched[item.field]
                                                  ? {
                                                      display: "block",
                                                    }
                                                  : {}
                                              }
                                            >
                                              {formik.errors[item.field] &&
                                              formik.touched[item.field] ? (
                                                <div className="error">
                                                  {formik.errors[item.field]}
                                                </div>
                                              ) : null}
                                            </Bform.Control.Feedback>
                                          </div>
                                          <div className="afterupload-image">
                                            {Array.from(
                                              this.state.attachments
                                            ).map((item, ind) =>
                                              this.getBase64(item, ind)
                                            )}
                                          </div>
                                          <div className="custom_image">
                                            {this.state.attachImages &&
                                              Object.keys(
                                                this.state.attachImages
                                              ).length > 0 && (
                                                <div className="afterupload-image mt-2">
                                                  {this.state.attachImages &&
                                                    Object.keys(
                                                      this.state.attachImages
                                                    ).map((item, ii) => {
                                                      return this.getBlobImages(
                                                        this.state.attachImages[
                                                          item
                                                        ],
                                                        item
                                                      );
                                                    })}
                                                </div>
                                              )}
                                            <div className="clone afterupload-image mt-2">
                                              {Object.keys(
                                                formik.values[item.field] || {}
                                              ).length > 0 &&
                                                Object.keys(
                                                  formik.values[item.field]
                                                ).map((it) => {
                                                  return (
                                                    <div className=" img-box">
                                                      <Error>
                                                        <ImagePreview
                                                          headImage={
                                                            formik.values[
                                                              item.field
                                                            ][it]
                                                          }
                                                          width="150px"
                                                          height="80px"
                                                        />
                                                      </Error>
                                                      <div
                                                        className="delete"
                                                        onClick={() =>
                                                          this.removeCloneImages(
                                                            it,
                                                            formik
                                                          )
                                                        }
                                                      >
                                                        <svg
                                                          width="11"
                                                          height="10"
                                                          viewBox="0 0 11 10"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            d="M8.21973 2.5L3.21973 7.5"
                                                            stroke="#737373"
                                                            stroke-width="1.33"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                          ></path>
                                                          <path
                                                            d="M3.21973 2.5L8.21973 7.5"
                                                            stroke="#737373"
                                                            stroke-width="1.33"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                          ></path>
                                                        </svg>
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </Col>
                                      );
                                    }
                                    let newoptions = [];
                                    for (let ip in item.options) {
                                      newoptions.push({
                                        label: `${item.options[ip].name}`,
                                        value:
                                          item.options[ip].user_uuid || item.ip,
                                      });
                                    }
                                    const values = newoptions.filter(
                                      (ite) =>
                                        ite.value === formik.values[item.field]
                                    );
                                    return (
                                      <Col
                                        md={item.attribute_grid}
                                        className="mb-3"
                                        key={index}
                                      >
                                        <div className="inputbox-group">
                                          <label
                                            className={
                                              "col-12 " +
                                              (item.is_required
                                                ? "form-label _required"
                                                : "")
                                            }
                                          >{`${this.firstUpper(
                                            item.headerName
                                          )}`}</label>
                                          <ReactSelect
                                            options={newoptions || []}
                                            isMulti={item.is_multiple}
                                            name="label"
                                            maxMenuHeight={175}
                                            placeholder={this.firstUpper(
                                              item.headerName
                                            )}
                                            ref={(el) =>
                                              (this.clearFormSelect[index] = el)
                                            }
                                            value={values}
                                            onChange={(value) => {
                                              formik.setFieldValue(
                                                item.field,
                                                value.value
                                              );
                                            }}
                                            onBlur={() =>
                                              formik.setFieldTouched(
                                                item.field,
                                                true
                                              )
                                            }
                                          />
                                          <Bform.Control.Feedback
                                            type="invalid"
                                            style={
                                              formik.errors[item.field] &&
                                              formik.touched[item.field]
                                                ? {
                                                    display: "block",
                                                  }
                                                : {}
                                            }
                                          >
                                            {formik.errors[item.field] &&
                                            formik.touched[item.field] ? (
                                              <div className="error">
                                                {formik.errors[item.field]}
                                              </div>
                                            ) : null}
                                          </Bform.Control.Feedback>
                                        </div>
                                      </Col>
                                    );
                                  })}
                                  {this.state.childBoards?.length > 1 && (
                                    <Col md={6}>
                                      <div className="inputbox-group child-group">
                                        <label className="form-label">
                                          Copy data from
                                        </label>
                                        <div className="main-child-parent">
                                          {this.state.childBoards.map(
                                            (child) => (
                                              <div className="form-check-child">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  value={
                                                    child.attribute_set_key
                                                  }
                                                  onChange={(evt) =>
                                                    this.getChildBoardValueHandler(
                                                      evt,
                                                      formik
                                                    )
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  for="flexCheckDefault"
                                                >
                                                  {child.attribute_set_name}
                                                </label>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                                {!this.state.isSaving ? (
                                  <Button
                                    className="muBtn _blue mt-3"
                                    text={
                                      this.props.match.params.uuid
                                        ? "Clone"
                                        : "Save"
                                    }
                                    type="submit"
                                  />
                                ) : (
                                  <Button
                                    className="muBtn _blue mt-3"
                                    text={"Saving..."}
                                    type="button"
                                  />
                                )}
                                &nbsp;&nbsp;
                                {this.props.match.params.attribute_set_key !==
                                  "support-ticket" &&
                                  this.props.match.params.uuid && (
                                    <Link
                                      className="btn btn-light"
                                      to={`${this.props.location.state?.prevPath}`}
                                    >
                                      Back
                                    </Link>
                                  )}
                              </Form>
                            );
                          }}
                        </Formik>
                      </div>
                    </div>
                  </Row>
                </div>
              </Container>
            </Error>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    attributes: state.boardAttribute,
    logindata: state.loginDetails.loginData,
    uploadAtt: state.boardAttribute.allAttachImage_add_listing?.["add_listing"],
    isUploadDone: state.boardAttribute?.isImageUpload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBoardAttributes: (key) => {
      dispatch(action.fetchattributelistingforboard(key));
    },
    uploadImage: (inputs) => {
      return dispatch(action.UploadImage(inputs));
    },
    updateAttachment: (inputs) => {
      dispatch(updateAttachmentData(inputs));
    },
    clearAllAttachment: () => {
      return dispatch(clearAllAttachment());
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddListing)
);
